export const applicationSubmitPost = {
  "id": "66fba862-191e-4da5-93ad-1d58d4859d6a",
  "status": "AUTO_APPROVED"
}